import styled from 'styled-components';

import { decrease, TouchArea } from '../BloodFront/styles';

// Cabeça
export const Head = styled(TouchArea)`
  top: ${(props) => (props.decrease ? decrease(24) : 24)}px;
  right: 0;
  left: 0;
  margin: auto;
`;

// Cotovelo esquerdo
export const LeftElbow = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(22) : 22)}px;
  top: ${(props) => (props.decrease ? decrease(149) : 149)}px;
`;

// Cotovelo direito
export const RightElbow = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(22) : 22)}px;
  top: ${(props) => (props.decrease ? decrease(149) : 149)}px;
`;

// Nádega esquerda
export const LeftButtock = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(59) : 59)}px;
  top: ${(props) => (props.decrease ? decrease(205) : 205)}px;
`;

// Nádega direita
export const RightButtock = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(59) : 59)}px;
  top: ${(props) => (props.decrease ? decrease(205) : 205)}px;
`;

// Panturrilha esquerda
export const LeftCalf = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(61) : 61)}px;
  top: ${(props) => (props.decrease ? decrease(326) : 326)}px;
`;

// Panturrilha direita
export const RightCalf = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(61) : 61)}px;
  top: ${(props) => (props.decrease ? decrease(326) : 326)}px;
`;

// Tornozelo esquerdo
export const LeftAnkle = styled(TouchArea)`
  left: ${(props) => (props.decrease ? decrease(62) : 62)}px;
  bottom: ${(props) => (props.decrease ? decrease(10) : 10)}px;
`;

// Tornozelo direito
export const RightAnkle = styled(TouchArea)`
  right: ${(props) => (props.decrease ? decrease(62) : 62)}px;
  bottom: ${(props) => (props.decrease ? decrease(10) : 10)}px;
`;
